import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgProhibit = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14 2.625A11.375 11.375 0 1 0 25.375 14 11.387 11.387 0 0 0 14 2.625ZM23.625 14a9.577 9.577 0 0 1-2.232 6.156L7.844 6.606A9.625 9.625 0 0 1 23.625 14Zm-19.25 0a9.577 9.577 0 0 1 2.232-6.156l13.549 13.55A9.624 9.624 0 0 1 4.375 14Z" />
  </svg>
);
export default SvgProhibit;
